<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-confirm-create-update-class-school" @hidden="resetModal">
            <div class=" container wrap-form-save-class-school">
                <h4>
                    <strong>Tạo lớp học</strong>
                </h4>
                <div class="row form-detail-item">
                    <div class="col-md-6">
                        <label for="nameSchool">Tên trường:</label>
                        <div class="text-content">
                            <strong>{{ dataClassSchool.nameSchool }}</strong>
                        </div>
                    </div>
                </div>
                <div class="row form-detail-item margin-top-10">
                    <div class="col-md-6">
                        <label for="nameSchool">Khối lớp:</label>
                        <div class="text-content">
                            <strong>{{ dataClassSchool.className }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="nameSchool">Tên lớp học:</label>
                        <div class="text-content">
                            <strong>{{ dataClassSchool.name }}</strong>
                        </div>
                    </div>
                </div>
                <div class="row form-detail-item margin-top-10">
                    <div class="col-md-6">
                        <label for="nameSchool">Môn học:</label>
                        <div class="text-content">
                            <strong>{{ dataClassSchool.subjectName }}</strong>
                        </div>
                    </div>
                </div>
                <div class="line">

                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-detail-item">
                            <label for="nameSchool">Mã lớp:</label>
                            <div class="text-content">
                                <strong>{{ dataClassSchool.code }}</strong>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-detail-item">
                            <label for="nameSchool">Mật khẩu:</label>
                            <div class="text-content">
                                <strong>{{ dataClassSchool.password }}</strong>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-center">
                        <b-button class="btn-copy" @click="handleCopyCodeAndPass">
                            <img class="icon-copy" src="@/assets/img/copy.png" />
                            Sao chép mã và mật khẩu
                        </b-button>
                    </div>
                    <div class="col-md-12 text-center">
                        <b-button class="btn-copy btn-copy-link" @click="handleCopyLinkRefClassSchool">
                            <img class="icon-link" src="@/assets/img/link.png" />
                            Sao chép đường liên kết
                        </b-button>
                    </div>
                </div>
                <div class="container form_action display-flex justify-content-space-around">
                    <button type="button"
                        class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-space-around line-height-1"
                        :disabled="isLoading" @click="handleHideModal">
                        Trở lại
                    </button>
                    <button type="submit"
                        class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-space-around line-height-1"
                        @click="handleSave" :disabled="isLoading">
                        Thêm mới
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { saveClassSchool } from './../_api/classSchoolServices'
import { APP_CONFIG } from "@/utils/constants";
import copy from 'copy-to-clipboard';
export default {
    name: "ModalConfirmCreateUpdate",
    props: {
        dataClassSchool: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }

    },
    data() {
        return {
            confirmActive: {},
            isLoading: false,
            domain: APP_CONFIG.domain,
        }
    },
    mounted() {

    },

    computed: {
        screenWidth() {
            return window.innerWidth;
        },

    },
    methods: {
        handleCopyLinkRefClassSchool() {
            let linkJoin = `${this.domain}/tham-gia-lop-hoc`
            this.copyToClipboard(linkJoin)
        },
        handleCopyCodeAndPass() {
            let text = `Mã lớp:${this.dataClassSchool.code} Mật khẩu:${this.dataClassSchool.password}`
            this.copyToClipboard(text)
        },
        copyToClipboard(text) {
            copy(text, {
                debug: true,
                message: 'Press #{key} to copy',
            });
        },
        handleSave() {
            let self = this
            saveClassSchool(this.dataClassSchool).then(res => {
                if (res && res.data && !res.errors) {
                    this.dataClassSchool.id = res.data.id
                    self.$toast.success('Thêm mới lớp học thành công')
                    self.handleHideModal()
                    self.$emit('handleDone')
                }

                const name = this.dataClassSchool.name + " - " + this.dataClassSchool.subjectName
                this.$router.push({
                    path: '/quan-ly-lop-hoc',
                    query: {
                        id: this.dataClassSchool.id,
                        nameClass: name
                    }
                });

            })


        },
        resetModal() {

        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-confirm-create-update-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            this.$refs['modal-confirm-create-update-class-school'].hide()
        },
        handleShowModal() {
            this.$refs['modal-confirm-create-update-class-school'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-copy {
    margin: 5px 0px 5px 0px;
    background: white;
    color: black;
    border: 1px solid #d5d2d2;

    .icon-copy,
    .icon-link {
        width: 20px;
    }
}

.line {
    height: 2px;
    background: #d5d2d2;
    margin-left: 50px;
    margin-right: 50px;
    margin-top: 40px;
}

.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justify-content-space-around {
    justify-content: space-around
}

.margin-top-10 {
    margin-top: 10px;
}

.text-center {
    text-align: center;
}
</style>